import { render, staticRenderFns } from "./FeaturedStudio.vue?vue&type=template&id=4e1d4bd7&"
import script from "./FeaturedStudio.vue?vue&type=script&lang=js&"
export * from "./FeaturedStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports